import React, { useEffect } from 'react';

import { Box, Flex, FlexProps, Select, useMantineTheme } from '@mantine/core';
import { Website } from 'shared/interfaces/Website';

interface BrowserContainerProps extends FlexProps {
  dark?: boolean;
  website?: Website;
  currentUrl?: string;
  onUrlChange?: (url: string) => void;
  children?: React.ReactNode;
}

export function BrowserContainer({
  dark,
  website,
  currentUrl,
  onUrlChange,
  children,
  ...flexProps
}: BrowserContainerProps) {
  const theme = useMantineTheme();
  const [urlItems, setUrlItems] = React.useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    if (website)
      setUrlItems([
        { value: website.url, label: website.url },
        ...website.subLinks.map((link) => ({ value: link, label: link }))
      ]);
  }, [website]);

  return (
    <Flex
      {...flexProps}
      direction="column"
      sx={{ borderRadius: theme.spacing.xs, border: `1px solid ${dark ? '#35363b' : '#EDEDED'}` }}>
      <Flex
        direction="row"
        align="center"
        mih={50}
        px="xs"
        bg={dark ? '#35363b' : '#EDEDED'}
        sx={{ borderTopLeftRadius: theme.spacing.xs, borderTopRightRadius: theme.spacing.xs }}>
        <Box w={12} m={3} h={12} bg={'red'} sx={{ borderRadius: '10px' }}></Box>
        <Box w={12} m={3} h={12} bg={'yellow'} sx={{ borderRadius: '10px' }}></Box>
        <Box w={12} m={3} h={12} bg={'green'} sx={{ borderRadius: '10px' }}></Box>
        {website && (
          <Select
            w="100%"
            mx={20}
            data={urlItems}
            maxDropdownHeight={200}
            onChange={(value) => onUrlChange?.(value ?? '')}
            value={currentUrl}
          />
        )}
      </Flex>
      {children}
    </Flex>
  );
}
